import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { evaluateMergedVars } from '@go-shared/lib/mergedVars';
import { MergedVariables } from '@go-shared/types/mergedVars';
import React, { useEffect, useState } from 'react';

export interface BubbleMergedVarHintChildProps {}

export interface BubbleMergedVarHintPropsBase {
  text: string;
  simple?: boolean;
  mergedVars?: MergedVariables;
}

export type BubbleMergedVarHintProps = {} & BubbleMergedVarHintPropsBase;

export default function BubbleMergedVarHint(props: BubbleMergedVarHintProps) {
  const [showVars, setShowVars] = useState(true);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(null);
  const { defaultLanguage } = useServerInfo();

  const [text] = evaluateMergedVars(
    props.text,
    undefined,
    [],
    defaultLanguage.key,
    defaultLanguage.key,
    props.mergedVars,
    (text, key, isMissing) =>
      `<span class="font-bold underline ${
        isMissing && !props.simple
          ? 'text-crimson'
          : showVars && !props.simple
            ? 'text-lime-darker'
            : ''
      }">${showVars ? text : `$${key}$`}</span>`
  );

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }

    const ts = setTimeout(() => {
      setShowVars(true);
    }, 5 * 1000);

    setTimer(ts);

    return () => clearTimeout(ts);
  }, [showVars]);

  return (
    <div
      onClick={() => (!props.simple ? setShowVars(!showVars) : undefined)}
      dangerouslySetInnerHTML={{ __html: text }}
      className="cursor-pointer"
    ></div>
  );
}
